import { OrderStatus } from "@foxone/api/src/models/defi";

export default {
  _setPaying(vue: Vue, data) {
    vue.$store.commit("app/SET_PAYING", data);
  },

  async requestPayOrder(vue: Vue, id: string, callback) {
    this._setPaying(vue, { visible: true });
    const payment = await vue.$api.defi.requestPayOrder(id);
    const channel = payment.channel;
    const url = vue.$common.utils.helper.genPayment({
      amount: payment.quantity,
      memo: channel.memo,
      assetId: channel.asset_id,
      recipient: channel.opponent_id,
      traceId: channel.trace_id
    });
    window.location.href = url;
    this._pullOrderResult(vue, id, callback);
  },

  async _pullOrderResult(vue: Vue, id: string, callback) {
    this._setPaying(vue, { visible: true });
    const order = await vue.$api.defi.getOrder(id);
    if (order.status === OrderStatus.UNPAID) {
      const timer = setTimeout(() => {
        this._pullOrderResult(vue, id, callback);
      }, 3000);
      this._setPaying(vue, { visible: true, timer });
    } else {
      this._setPaying(vue, { visible: false });
      vue.$common.utils.helper.toast(vue, {
        message: vue.$t("common.payment.success") as string,
        color: "success"
      });
      // success handler
      if (callback && typeof callback === "function") {
        callback();
      }
    }
  }
};
